document.addEventListener("DOMContentLoaded", function(){

  document.querySelectorAll(".button_label").forEach(label => {

    const text = label.textContent.trim();
    label.innerHTML = "";

    [...text].forEach((char, i) => {

      const span = document.createElement("span");
      span.classList.add("letter");

      span.style.animationDelay = `${i * 0.05}s`;
      span.innerHTML = char === " " ? "&nbsp;" : char;

      label.appendChild(span);

    });

  });

});

  /* Bold Subscriptions widget — extracted as reusable function */
  function initBoldWidgets(container) {
    if (!window.BOLD || !window.BOLD.subscriptions || !window.BOLD.subscriptions.data.subscriptionGroups.length) return;

    const group = window.BOLD.subscriptions.data.subscriptionGroups[0];
    const billingRules = group.billing_rules;
    const discount = group.percent_discount;

    const productCards = (container || document).querySelectorAll('.card-wrapper[data-subs="1"]');

    productCards.forEach(function (card) {
      /* Skip cards that already have the widget */
      if (card.querySelector('.bold-card-widget')) return;

      const priceEl = card.querySelector('.price-item--regular') || card.querySelector('.price-item');
      if (!priceEl) return;

      const rawPrice = priceEl.textContent.replace(/[^0-9.]/g, '');
      const originalPrice = parseFloat(rawPrice);
      if (isNaN(originalPrice)) return;

      const discountedPrice = (originalPrice * (1 - discount / 100)).toFixed(2);

      const productLink = card.querySelector('a.full-unstyled-link') || card.querySelector('a[href*="/products/"]');
      const productUrl = productLink ? productLink.getAttribute('href') : '#';

      let intervalsHTML = '';
      billingRules.forEach(function (rule, index) {
        intervalsHTML += `
          <label class="bold-interval-option">
            <input type="radio" name="bold-interval-${card.dataset.boldId || index}" value="${rule.id}" ${index === 0 ? 'checked' : ''}>
            <span class="bold-interval-label">Every ${rule.interval_name}</span>
            <span class="bold-interval-price">$${discountedPrice}</span>
          </label>
        `;
      });

      const widget = document.createElement('div');
      widget.classList.add('bold-card-widget');
      widget.innerHTML = `
        <label class="bold-option-box bold-onetime">
          <input type="radio" name="bold-purchase-type-${Math.random().toString(36).substr(2,5)}" value="onetime" checked>
          <span class="bold-option-label">One-time Purchase</span>
          <span class="bold-option-price">$${originalPrice.toFixed(2)}</span>
        </label>
        <div class="bold-option-box bold-subscribe">
          <div class="bold-subscribe-header">
            <span class="bold-option-label">Subscribe and Save</span>
            <span class="bold-option-price">$${discountedPrice}</span>
          </div>
        </div>
      `;

      const priceSection = card.querySelector('.price');
      if (priceSection) priceSection.style.display = 'none';

      const cardInfo = card.querySelector('.card__info') || card.querySelector('.card-information');
      if (cardInfo) {
        cardInfo.appendChild(widget);
      }
    });
  }

  /* Expose globally so load-more can call it */
  window.initBoldWidgets = initBoldWidgets;

  function waitForBold(callback) {
    if (window.BOLD && window.BOLD.subscriptions && window.BOLD.subscriptions.data.subscriptionGroups.length > 0) {
      callback();
    } else {
      setTimeout(function () { waitForBold(callback); }, 500);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    waitForBold(function () {
      initBoldWidgets(document);
    });
  });

(function () {
  function initSliderDots(sliderComponent) {
    const slider = sliderComponent.querySelector('[id^="Slider-"]');
    const dots = sliderComponent.querySelectorAll('.slider-counter__dot');

    if (!slider || !dots.length) return;

    function updateDots(activeIndex) {
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === activeIndex);
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', (event) => {
        // Prevent any default button/anchor behaviour
        event.preventDefault();
        // Stop the click bubbling up to slider-component or window scroll handlers
        event.stopPropagation();

        const index = parseInt(dot.dataset.index, 10);
        const slides = slider.querySelectorAll('.slider__slide');
        const targetSlide = slides[index];

        if (!targetSlide) return;

        // Scroll only horizontally inside the slider track.
        // scrollLeft moves the slider strip without touching window scroll position.
        const targetScrollLeft = targetSlide.offsetLeft - slider.offsetLeft;

        slider.scrollTo({
          left: targetScrollLeft,
          behavior: 'smooth'
        });

        // Move focus to the dot without letting the browser scroll anything
        dot.focus({ preventScroll: true });

        // Sync dots after the smooth scroll has settled
        setTimeout(() => updateDots(index), 300);
      });
    });

    // Sync dots when the user swipes or Dawn's own prev/next buttons are used
    slider.addEventListener('scroll', () => {
      const slides = slider.querySelectorAll('.slider__slide');
      if (!slides.length) return;
      const slideWidth = slides[0].offsetWidth || 1;
      const activeIndex = Math.round(slider.scrollLeft / slideWidth);
      updateDots(activeIndex);
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('slider-component').forEach((sliderComponent) => {
      if (sliderComponent.querySelector('.slider-counter--dots')) {
        initSliderDots(sliderComponent);
      }
    });
  }

  // Watch for product-recommendations AJAX content injection
  function observeProductRecommendations() {
    document.querySelectorAll('product-recommendations').forEach((el) => {
      const observer = new MutationObserver(() => {
        el.querySelectorAll('slider-component').forEach((sliderComponent) => {
          if (
            sliderComponent.querySelector('.slider-counter--dots') &&
            !sliderComponent.dataset.dotsInitialized
          ) {
            sliderComponent.dataset.dotsInitialized = 'true';
            initSliderDots(sliderComponent);
          }
        });
      });
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { init(); observeProductRecommendations(); });
  } else {
    init();
    observeProductRecommendations();
  }
})();


  (function () {
    if (window.matchMedia('(min-width: 750px)').matches) return;

    let blocks = document.querySelectorAll('.footer-block');

    blocks.forEach(function (block) {
      let heading = block.querySelector('.footer-block__heading');
      let content = block.querySelector('.footer-block__details-content');

      if (!heading || !content) return;

      block.classList.add('footer-block--accordion');

      let caret = document.createElement('span');
      caret.className = 'footer-accordion__caret';
      caret.setAttribute('aria-hidden', 'true');
      caret.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
      heading.appendChild(caret);

      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');
      heading.setAttribute('aria-expanded', 'false');

      function toggle() {
        let isOpen = block.classList.contains('is-open');

        blocks.forEach(function (otherBlock) {
          if (otherBlock !== block && otherBlock.classList.contains('is-open')) {
            otherBlock.classList.remove('is-open');
            let otherHeading = otherBlock.querySelector('.footer-block__heading');
            if (otherHeading) otherHeading.setAttribute('aria-expanded', 'false');
          }
        });

        block.classList.toggle('is-open', !isOpen);
        heading.setAttribute('aria-expanded', String(!isOpen));
      }

      heading.addEventListener('click', toggle);

      heading.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });
    });
  })();


  (function () {
    var MEDIA_SELECTORS = 'img, video, iframe, svg, canvas, picture';

    function isEmptyNode(el) {
      if (el.querySelector(MEDIA_SELECTORS)) return false;

      var text = el.textContent.replace(/[\u00a0\u200b\u200c\u200d\ufeff]/g, '').trim();
      return text === '';
    }

    function clean() {
      // var content = document.querySelector('.art-layout__content');
      var content = document.querySelector('.art-layout__content, .accordion__content.rte');
      if (!content) return;

      var paragraphs = content.querySelectorAll('p');
      paragraphs.forEach(function (p) {
        if (isEmptyNode(p)) {
          p.style.display = 'none';
        }
      });
      var headings = content.querySelectorAll('h1, h2, h3, h4, h5, h6');
      headings.forEach(function (h) {
        if (isEmptyNode(h)) {
          h.style.display = 'none';
        }
      });
      var brs = content.querySelectorAll('br');
      brs.forEach(function (br) {
        var parent = br.parentElement;
        if (!parent) return;
        var clone = parent.cloneNode(true);
        clone.querySelectorAll('br').forEach(function (b) {
          b.remove();
        });
        if (isEmptyNode(clone)) {
          parent.style.display = 'none';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', clean);
    } else {
      clean();
    }
  })();